import React from 'react';
import { useState } from 'react';
import { useSupportContacts, whatsappUrl } from "../../utils/useSupportContacts";

const SupportAndDownloadButtons = () => {
  const support = useSupportContacts();
  const supportUrl = whatsappUrl(support?.whatsapp) || support?.telegram || "";
  const [hoveredSupport, setHoveredSupport] = useState(false);
  const [hoveredDownload, setHoveredDownload] = useState(false);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '400px',
     
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      padding: '12px',
      fontWeight: 'bold',
      borderRadius: '8px',
      cursor: 'pointer',
      border: '2px solid',
      transition: 'all 0.2s ease',
      marginTop: "15px"

    },
    supportButton: {
      backgroundColor: hoveredSupport ? '#333333' : '#222222',
      color: 'white',
      borderColor: '#333333',
    },
    downloadButton: {
      backgroundColor: hoveredDownload ? '#FFD700' : '#FFCC00',
      color: '#222222',
      borderColor: '#FFCC00',
    },
    icon: {
      width: '20px',
      height: '20px',
      marginRight: '8px',
    }
  };

  return (
    <div style={styles.container}>
      <button 
        style={{...styles.button, ...styles.supportButton}}
        onClick={() => supportUrl && window.open(supportUrl, "_blank", "noopener,noreferrer")}
        onMouseEnter={() => setHoveredSupport(true)}
        onMouseLeave={() => setHoveredSupport(false)}
      >
        <svg style={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="white"/>
        </svg>
        24/7 Customer Support
      </button>
      
      <button 
        style={{...styles.button, ...styles.downloadButton}}
        onMouseEnter={() => setHoveredDownload(true)}
        onMouseLeave={() => setHoveredDownload(false)}
      >
        <svg style={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z" fill="currentColor"/>
        </svg>
        Download App
      </button>
    </div>
  );
};

export default SupportAndDownloadButtons;